import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

export type SkimmerState = {
  time: number;
  position: number;
  isVisible: boolean;
};

export type FilmStripState = {
  skimmerState: SkimmerState;
};

// INITIAL STATE
const initialFilmStripState: FilmStripState = {
  skimmerState: {
    time: 0,
    position: 0,
    isVisible: false,
  },
};

// REDUCER
const filmstripSlice = createSlice({
  name: 'filmstrip',
  initialState: initialFilmStripState,
  reducers: {
    UPDATE_SKIMMER: (state, action: PayloadAction<SkimmerState>) => {
      return {
        ...state,
        skimmerState: { ...action.payload },
      };
    },
    RESET_FILMSTRIP_STATE: () => {
      return initialFilmStripState;
    },
  },
});

export const skimmerStateSelector = createSelector(
  (state: AppState) => state.filmstrip,
  state => state.skimmerState,
);

export const { UPDATE_SKIMMER, RESET_FILMSTRIP_STATE } = filmstripSlice.actions;

export default filmstripSlice.reducer;
